import apiClient from '@/services/apiClient';

// Label data for a combo session's stickers, priced in the session's plan channel (label-data → pricing_type).
// Throws instead of returning blank data when Rates Master has no row for that channel (would print Rs.0.00).
export const fetchComboLabelData = async (labelInfo, templates, findTemplateByName) => {
  const pricingType = labelInfo.pricing_type || 'TN';
  const barcodes = [...new Set((labelInfo.usns || []).map((u) => u.barcode).filter(Boolean))];
  const matchedTemplate = findTemplateByName(labelInfo.usns?.[0]?.print_template || '');
  const res = await apiClient.post('/main-labels/preview-batch', {
    barcodes,
    pricing_type: pricingType,
    template_id: matchedTemplate?.template_id || templates[0]?.template_id,
    fallback_barcode: labelInfo.item_barcode,
  });
  const missing = res.data.missing_rate || [];
  if (missing.length) {
    const other = (res.data.rate_options || []).join(', ');
    throw new Error(
      `No ${pricingType} price in Rates Master for ${missing.join(', ')} — stickers NOT printed (MRP would be blank).` +
      (other ? ` Rates exist for: ${other}.` : '') + ' Fix Rates Master, then print again.'
    );
  }
  return { labelDataMap: res.data.results || {}, defaultTemplate: matchedTemplate || res.data.template, pricingType };
};
